import React from 'react';
import { useTranslation } from 'react-i18next';
import VoucherRegisterReport from '@/components/finance/report-document/VoucherRegisterReport';

const ReceiptRegisterPage: React.FC = () => {
  const { t } = useTranslation('finance');
  return (
    <div aria-label={t('receiptRegister')}>
      <VoucherRegisterReport kind="receipt" />
    </div>
  );
};

export default ReceiptRegisterPage;
